module.exports = __webpack_public_path__ + "static/vanishing-words-877d73fbab185a357aa5c6fff85f3e78.jpg";